<template>
  <div class="g-layout" ref="mainContainer">
    <ic-header :menu-list="menuList"></ic-header>
    <div class="g-layout-main" v-if="loaded">
      <router-view></router-view>
    </div>
    <ic-tool></ic-tool>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import Header from "_c/Header";
import Footer from "./Footer";
import Tool from "_c/Tool";
import { Loading } from "element-ui";
import { mapState, mapActions } from "vuex";
export default {
  name: "portal-layout",
  data() {
    return {
      menuList: [
        { name: "首页", link: "/portal" },
        { name: "新闻资讯", link: "/portal/column/news" },
        { name: "通知公告", link: "/portal/column/notice" },
        { name: "政策发布", link: "/portal/column/policy" },
        { name: "特色产业学院", link: "/portal/college" },
        { name: "下载专区", link: "/portal/download" },
        { name: "监控中心", link: "/portal/monitor", newWindow: true }
      ],
      loaded: false
    };
  },
  computed: {
    ...mapState("school", ["schoolData"])
  },
  components: {
    [Header.name]: Header,
    [Footer.name]: Footer,
    [Tool.name]: Tool
  },
  async mounted() {
    console.log("schoolData", this.schoolData);
    let loadingOptions = {
      target: this.$refs.mainContainer,
      fullscreen: false
    };
    let loadingInstance = Loading.service(loadingOptions);
    if (!this.schoolData) {
      console.log("go Init");
      await this.setSchoolData();
      this.loaded = true;
    } else {
      this.loaded = true;
    }
    loadingInstance.close();
  },
  methods: {
    ...mapActions("school", ["setSchoolData"])
  }
};
</script>

<style lang="scss" scoped>
.g-layout {
  &-main {
    padding-bottom: 230px;
  }
  ::v-deep .comp-header {
    .top {
      padding-bottom: 0;
    }
  }
}
</style>
